import React from 'react';
import classes from './Input.css';

const input = (props) => {
  let inputElement = null;
  let inputClasses = [classes.FormInput]
  let formGroupClasses = [classes.FormGroup];
  let labelClasses = [classes.FormLabel]

  let message = `Please provide a ${props.label.toLowerCase()}`;

  if (props.config.value !== '' && props.config.id === 'zip') {
    message = 'Provide 5 character zipcode'
  }

  if (props.config.id === 'password' && props.config.value !== '') {
    message = 'Password must be atleast 8 characters long and contain a symbol, lowercase letter, and capital letter'
  }

  if (props.config.id === 'confirmPassword') {
    message = 'Passwords do not match';
  }

  if (props.config.value !== '' && props.config.id === 'email') {
    message = 'Provide a valid email'
  }

  if (!props.valid && props.touched) {
    inputClasses.push(classes.Invalid);
    formGroupClasses.push(classes.InvalidGroup);
  }

  switch (props.inputType) {
    case ('input'):
      inputElement = <input className={inputClasses.join(' ')} onBlur={() => { props.markTouched(props.config.id) }} onChange={(event) => { props.update(props.config.id, event.target.value) }}  {...props.config} />
      break;
    case ('textarea'):
      inputElement = <textarea className={classes.FormTextArea} {...props.config} onChange={(event) => { props.update(props.config.id, event.target.value) }} />
      break;
    case ('select'):
      const options = props.config.options.map((option) => {
        return <option key={option.value} value={option.value}>{option.displayValue}</option>
      })

      inputElement = <select className={classes.FormSelect} onChange={(event) => { props.update(props.config.id, event.target.value) }} >
        {options}
      </select>
      break;
    default:
      inputElement = <input />
  }



  switch (props.formGroupSize) {
    case ('half'):
      formGroupClasses.push(classes.FormGroupHalf)
      break;
    case ('whole'):
      formGroupClasses.push(classes.FormGroupWhole)
      break;
    case ('threeQuarters'):
      formGroupClasses.push(classes.FormGroupThreeQuarters)
      break;
    case ('quarter'):
      formGroupClasses.push(classes.FormGroupQuarter)
      break;
    default:
      return null;
  }

  if (props.noLabel) {
    labelClasses.pop();
    formGroupClasses.push(classes.NoLabelGroup)
    labelClasses.push(classes.NoLabel);
  }





  return (
    <div className={formGroupClasses.join(' ')} data-description={message}>
      <label className={labelClasses.join(' ')} htmlFor={props.id}>{props.label}</label>
      {inputElement}
    </div>
  )
}

export default input;




// WEBPACK FOOTER //
// ./src/components/UI/Input/Input.jsx